export default "__VITE_ASSET__4c86dd7e__"